import { useNavigate } from "react-router";
import styled from "styled-components";
import { theme } from "../../../helpers/theme";
import SessionService from "../../../services/session-service";

const NotFound = () => {
  let navigate = useNavigate();
  return (
    <PageContainer>
      <NotFoundInfo>404 - Strona nie została odnaleziona</NotFoundInfo>
      <NotFoundRedirect onClick={() => navigate("/")}>
        IDŹ DO STRONY GŁÓWNEJ
      </NotFoundRedirect>
    </PageContainer>
  );
};

export default NotFound;

const user = SessionService.getUser();
const isLoged = user && user.token_dostepu !== null ? true : false;
const logedMarginDetection = () => {
  if (isLoged) {
      if (window.screen.width > 1024) {
          return true;
      } else {
          return false;
      }
  } else {
      return false;
  }
}

const PageContainer = styled.div`
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 400px;
  margin-left: ${logedMarginDetection() ? "300px" : 0};
`;
const NotFoundInfo = styled.span`
  font-weight: bold;
  font-size: 3rem;
  text-align: center;
  @media ${theme.device.Mtablet} {
    font-size: 1.6rem;
  }
  margin-bottom: 20px;
  padding-left: 10px;
`;
const NotFoundRedirect = styled.span`
  font-weight: bold;
  font-size: 1.6rem;
  @media ${theme.device.Mtablet} {
    font-size: 1rem;
  }
  color: ${theme.colors.blue01_active};
  cursor: pointer;
`;
